<!--
  新建dialog框
  新建工单，编辑工单，新建跟进记录
  prop:
    addnewProp{
      id: 编辑表单时需要有 id
      // 业务流转时有一下三个参数
      refId: 当前id
      type: 当前模块
      module: 新增表单所属模块
      formTitle: 如果表单的标题需要特殊处理，设置formTitle属性
    }

  emit:
    refresh: 提交刷新列表请求
    closeDialog: 注销当前页面
 -->

<template>
  <div class="add-new">
    <el-dialog
      :title="addnewProp.formTitle ? addnewProp.formTitle : formTitle"
      :visible.sync="dialogFormVisible"
      width="740px"
      :modal="modal"
      :before-close="cancelDialog">
      <el-form :rules="rules" :model="form" ref="ruleForm" class="addnew-from">
        <el-form-item
          v-for="item in formData"
          v-if="item.attr !== 'estimateTime'"
          :label="item.attrName"
          :prop="item.attr"
          :key="item.attr"
          :label-width="formLabelWidth"
          >
          <!-- 无编辑权限 -->
          <el-input
            v-if="item.attrVisible"
            value="* * * * * *"
            :disabled="true">
          </el-input>
          <!-- 普通文本框 -->
          <el-input
            :disabled="item.nonEditable===1"
            v-else-if="item.fieldType===1"
            :placeholder="item.placeholder"
            v-model="form[item.attr]">
          </el-input>
          <!-- 数字文本框 -->
          <el-input
            :disabled="item.nonEditable===1 || isMoneyEditable(item)"
            v-else-if="item.fieldType===2"
            v-model="form[item.attr]"
            @change="isShowNextPayAmount(item)"
            @keyup.native="onInput(item)"
            :placeholder="item.placeholder"
            >
            <template
              v-if="item.unit"
              slot="append">{{item.unit}}
            </template>
          </el-input>
          <!-- 下拉选择框 自定义 -->
          <el-select clearable
            filterable
            :disabled="item.nonEditable===1"
            v-else-if="item.fieldType===3 && item.valueArrMap"
            v-model="form[item.attr]"
            :placeholder="item.placeholder"
            @change="selectHandle(item.attr)">
            <el-option
              v-for="arr in item.valueArrMap"
              :key="arr.key"
              :label="arr.value"
              :value="arr.key">
            </el-option>
          </el-select>
          <!-- 下拉选择框 普通 -->
          <el-select clearable
          filterable
            :disabled="item.nonEditable===1"
            :placeholder="item.placeholder"
            v-else-if="item.fieldType===3 && item.initValue"
            v-model="form[item.attr]">
              <el-option
                v-for="option in strToArr(item.initValue)"
                :key="option"
                :value="option">
              </el-option>
          </el-select>
          <!-- 日期选择 -->
          <el-date-picker
            v-else-if="item.fieldType ===4 && form.type === '3' && moduleName === 'workReportApi' && item.attr === 'reportDate'"
            :disabled="fuction(item)"
            :editable="false"
            v-model="form[item.attr]"
            type="month"
            placeholder="请选择月份"
            value-format="yyyy-MM-dd"
            @change="datepicker(item)">
          </el-date-picker>
          <el-date-picker
            :disabled="fuction(item)"
            :editable="false"
            v-else-if="item.fieldType===4"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            v-model="form[item.attr]"
            @change="datepicker(item)">
          </el-date-picker>
          <!-- 图片上传 -->
          <template v-else-if="item.fieldType===5 || item.fieldType===6">
            <v-upload
              :attrValue="form[item.attr]"
              :defaultList = "item.attrValue"
              type="image">
            </v-upload>
          </template>
          <!-- 多行文本 -->
          <el-input
            :disabled="item.nonEditable===1"
            v-else-if="item.fieldType===7"
            type="textarea"
            v-model="form[item.attr]"
            :placeholder="item.placeholder"
            auto-complete="off">
          </el-input>
          <!-- 文件上传 -->
          <template v-else-if="item.fieldType===8">
            <v-upload
              :attrValue="form[item.attr]"
              :defaultList="item.attrValue"
              type="file">
            </v-upload>
            <el-checkbox-group :value="form[item.attr]" v-show="false">
              <el-checkbox
                v-for="(file,index) in form[item.attr]"
                :key="file.attachIndex+index"
                :label="file.filename">
              </el-checkbox>
            </el-checkbox-group>
          </template>
          <!-- 多选框 -->
          <el-checkbox-group
            :disabled="item.nonEditable===1"
            v-else-if="item.fieldType===9"
            v-model="form[item.attr]">
            <el-checkbox
              v-for="(option, index) in strToArr(item.initValue)"
              :label="option"
              :key="index"
              :name="item.attr">
            </el-checkbox>
          </el-checkbox-group>
          <!-- 下次跟进提醒 -->
          <el-switch
            v-else-if="item.attr === 'ifRemind'"
            v-model="form[item.attr]"
            @change="remindChange">
          </el-switch>
          <!-- 星星 -->
          <template v-else-if="item.fieldType===10">
            <el-rate
              style="padding-top: 7px"
              v-model="form[item.attr]">
            </el-rate>
            <el-input
              v-show="false"
              :value="form[item.attr]">
            </el-input>
          </template>
          <!-- 生日 -->
          <template v-else-if="item.fieldType===37">
            <birthday
              :item="item"
              :form="form">
            </birthday>
          </template>
          <!-- 其他 -->
          <component
            v-else
            :ref="moduleName"
            :is="moduleName"
            :item="item"
            :form="form"
            :detailId="addnewProp.id"
            :isNameCheck="isNameCheck"
            :isCheckRepeat="isCheckRepeat"
            :listData="checkListData"
            :child="routeChild"
            @showProduct="productShow"
            @addNew="addNew"
            @change="handleFieldEmit"
            @communicatePlan="communicatePlan"
            @getVisitPlanList="getVisitPlanList"
            @refundProTotalMoney="refundProTotalMoney"
            >
          </component>
        </el-form-item>
        <template v-if="nextPayAmount">
          <el-form-item label="下次预计回款时间" prop="estimateTime" :label-width="formLabelWidth">
            <el-date-picker
              v-model="form.estimateTime"
              :editable="false"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              >
            </el-date-picker>
          </el-form-item>
        </template>

        <template v-if="nextRemind">
          <el-form-item label="下次跟进时间" prop="followTime" :label-width="formLabelWidth">
            <el-date-picker
              v-model="form.followTime"
              :editable="false"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              :picker-options="disableBefore"
              placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="提醒" prop="notifyType" :label-width="formLabelWidth">
            <el-select v-model="form.notifyType" placeholder="请选择">
              <el-option
                v-for="item in notifyType"
                :key="item.label"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提醒时间" v-if="form.notifyType === 5" prop="notifyTime" :label-width="formLabelWidth">
            <el-date-picker
              v-model="form.notifyTime"
              :editable="false"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              :picker-options="disableBefore"
              placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注" :label-width="formLabelWidth" prop="content">
            <el-input type="textarea" v-model="form.content"></el-input>
          </el-form-item>
          <el-form-item label="加入访客" :label-width="formLabelWidth">
            <el-checkbox v-model="form.plan">将此次提醒加入访客计划</el-checkbox>
          </el-form-item>
        </template>
        <div v-if="saleStage" class="v-warning">您开启了一个没有字段的阶段反馈！</div>
      </el-form>
      <!-- 发票管理 -->
      <add-invoice
        ref="addInvoice"
        v-if="moduleName === 'invoice' && form.customerName && form.customerName.id"
        :id="addnewProp.id"
        :customerId="form.customerName"
        :invoice="invoice"
        :express="express">
      </add-invoice>

      <!-- 回款红冲新建 -->
      <add-payment
        v-if="moduleName === 'paymentSheetApi' && addnewProp.isRed"
        :addnewProp="addnewProp"
        :id="addnewProp.refId"
        :checkedInvoices="checkedInvoices"
        :checkedPaymentSheets="checkedPaymentSheets"
        :form="form"
        @updateTotalMoney="updateRefundAmount"
      ></add-payment>
      <!-- 退货退款 -->
      <add-refund
        v-if="moduleName === 'refund'"
        :checkedInvoices="checkedInvoices"
        :checkedPaymentSheets="checkedPaymentSheets"
        :form="form"
        @updateTotalMoney="updateRefundAmount">
      </add-refund>
      <div slot="footer" class="dialog-footer">
        <p class="tips" v-if="isApproval" style="display: inline-block; float: left; padding-top: 10px; color: #ff7c35; font-size: 12px;">
          {{`*已开启${moduleMap[moduleName]}审批，新增${moduleMap[moduleName]}进入待审批中，且暂不在${moduleMap[moduleName]}列表中显示。`}}
        </p>
        <el-button @click="cancelDialog">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">{{isApproval ? '提交审批' : addnewProp.relation === 'contactApi' ? '确认' : '提 交'}}</el-button>
      </div>
    </el-dialog>

        <!-- 选择关联产品 Dialog(合同，机会) -->
    <template v-if="productCAOshow">
      <select-product
        class="add-btn"
        v-if="productType === 'add'"
        :moduleName="moduleName"
        :form="form"
        :modal="modal"
        :showClassify="true"
        :productType="productType"
        :selectIdArr="selectIdArr"
        :instockproduct="(form.products && form.products.productList) || form.products || form.productList"
        @showProduct="productShow"
        @getProductList="getProductList"
        @closeSelectPro="productCAOshow = false">
      </select-product>
      <products
        ref="products"
        v-else-if="productType === 'edit'"
        :moduleName="moduleName"
        :modal="modal"
        :surchargeList="form.products.surchargeList"
        :productList="(form.products && form.products.productList) || form.products || form.productList"
        :selectProducts="secondProductList"
        :decimalPrecisionMap="decimalPrecisionMap"
        @selectId="selectId"
        @showProduct="productShow"
        @emitProductsData="getCAOProductsData"
        @close="productCAOshow = false"
        @closeForDetail="productsDialog = false">
      </products>
    </template>

    <div class="v-modal" v-if="!modal && showModal"></div>
    <add-new
      ref="addNew"
      v-if="addnewShow"
      :curTemplate="curTemplate"
      :addnewProp="addnewPropCopy"
      @closeDialog="addnewShow=false"
      :modal="modal"
      @refresh="refresh"
    >
    </add-new>
  </div>

</template>
<script>
import Vue from 'vue'
import * as api from 'src/api'
import * as utils from 'src/utils'
import * as common from 'src/config/common-config'
import state from 'src/store/'
import { Message } from 'element-ui'
import { mapGetters, mapActions } from 'vuex'
import Birthday from 'components/fieldtype/date-birthday'
import vUpload from 'components/fieldtype/upload'
import selectProduct from 'components/fieldtype/select-product.vue' // 最新产品弹框
import products from 'components/fieldtype/products'
import supplier from 'components/fieldtype/supplier/index'
import purchase from 'components/fieldtype/purchase/index'
import returnedPurchase from 'components/fieldtype/returned-purchase/index'
import transfer from 'components/fieldtype/transfer/index'
import inventory from 'components/fieldtype/inventory/index'
import instock from 'components/fieldtype/instock/index'
import outstock from 'components/fieldtype/outstock/index'
import customerApi from 'components/fieldtype/customer/index'
import contactApi from 'components/fieldtype/contacts/index'
import opportunityApi from 'components/fieldtype/opportunity/index'
import contractApi from 'components/fieldtype/contract/index'
import communicateApi from 'components/fieldtype/communicate/index'
import assemble from 'components/fieldtype/assemble/index'
import customerExpress from 'components/fieldtype/customer-express/index'
import invoice from 'components/fieldtype/invoice/index'
import addInvoice from 'components/fieldtype/invoice/add-invoice'
import paymentSheetApi from 'components/fieldtype/payment-sheet/index'
import workReportApi from 'components/fieldtype/work-report'
import refund from 'components/fieldtype/refund/index'
import addRefund from 'components/fieldtype/refund/add-refund'
import workOrder from 'components/fieldtype/work-order/index'
import addPayment from 'components/fieldtype/payment-sheet/add-payment'

import addNew from './add-new'

// 自定义校验规则
const checkDate = (rule, value, callback) => {
  if (!value) {
    return callback(new Error())
  }
  callback()
}

const checkNumber = (rule, value, callback) => {
  if (value === '' && rule.required) {
    return callback(new Error(`请输入${rule.attrName}`))
  }
  // 小数位超出提示
  if (value.toString().indexOf('.') !== -1 && value.toString().split('.')[1].length > rule.num) {
    return callback(new Error(`该字段限制小数位数不能大于${rule.num}`))
  }

  if (value && isNaN(value)) {
    return callback(new Error('请输入正确的数字类型'))
  }
  callback()
}

let lazy

export default {
  created () {
    if (this.addnewProp.relation === 'contactApi') {
      this.customerAddContact()
    } else {
      this.initAddnew()
    }
  },
  props: {
    addnewProp: {
      type: Object,
      required: true
    },

    curTemplate: {
      type: Object
    },

    // 是否显示遮罩
    modal: {
      type: Boolean,
      default: true
    }
  },
  name: 'addNew',
  data () {
    return {
      productType: '',
      productsDialog: false, // 折扣弹框显隐
      secondProductList: [], // 合同机会选中的产品未经折扣弹框处理过
      selectIdArr: [], // 编辑时候已选产品
      nonEditable: false, // 是否禁止编辑
      dialogFormVisible: false,
      showModal: false,
      // 原始数据
      formData: [],
      // 要提交的数据
      form: {},
      formLabelWidth: '164px',
      // 验证规则
      rules: {},
      productshow: false,
      // 是否显示为 审批按钮
      isApproval: false,
      moduleMap: common.moduleMap,
      // 客户查重
      isNameCheck: false,
      // 顯示查重列表
      isCheckRepeat: false,
      // 电话号码查重
      isPhoneCheck: false,
      // 是否开启下次跟进提醒
      nextRemind: false,
      formatTime: '',
      notifyType: [
        {
          label: '提前15分钟',
          value: 0
        },
        {
          label: '提前1小时',
          value: 1
        },
        {
          label: '提前1天',
          value: 2
        },
        {
          label: '提前3天',
          value: 3
        },
        {
          label: '提前1周',
          value: 4
        },
        {
          label: '自定义时间',
          value: 5
        }
      ],
      disableBefore: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      // 兼容销售阶段无返回值的情况
      saleStage: false,
      // 发票管理
      invoice: '',
      express: '',
      opUUID: '', // 防止重复提交
      birthdayRequired: false, // 是否校验生日字段
      addnewPropCopy: {},
      addnewShow: false,
      paymentAmount: '',
      nextPayAmount: false, // 是否出现下次预计汇款时间
      productCAOshow: false, // 合同机会关联产品
      // 退货退款相关
      checkedInvoices: [], // 已选发票
      checkedPaymentSheets: [], // 已选回款单
      refundAmount: '', // 合计退款金额
      checkName: '', // 编辑时需要原来名字不需要查
      checkListData: [], // 模糊查重的列表
      visitPlanList: [], // 访客计划列表
      workOrder: {
        templateId: '',
        mainUser: ''
      },
      templateId: '', // 工单模板id
      isAmountEquals: false, // 新建合同时，回款总金额是否等于合同金额
      decimalPrecisionMap: {}, // 产品精度
      checkPayments: false
    }
  },
  computed: {
    ...mapGetters([
      'getAttr',
      'getErrorCode',
      'selectProducts',
      'isOpenAddNew',
      'curContact',
      'explains',
      'contactArray',
      'contactType',
      'delContactArray',
      'selectProducts',
      'paymentForm',
      'editPaymentData',
      'addPaymentData',
      'getAliasList'
    ]),
    moduleName () {
      if (this.addnewProp.module) {
        return this.addnewProp.module
      }
      return state.getters.moduleName
    },
    formTitle () {
      if (this.addnewProp.id && this.addnewProp.id !== '0') {
        return `编辑${this.getFormTitle() || this.moduleMap[this.moduleName]}`
      } else {

        // 阶段反馈不叫新建，叫填写
        if (this.moduleName === 'stageFeedbackApi') {
          return `填写${this.moduleMap[this.moduleName]}`
        }
        return `新建${this.getFormTitle(this.moduleName) || this.moduleMap[this.moduleName]}`
      }
    },
    // 子页面
    routeChild () {
      return this.$route.params.child || ''
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions([
      'updateSelect',
      'setAttr',
      'setSupplierId',
      'setWarehouseId',
      'setErrorCode',
      'checkPayment',
      'setPaymentType',
      'initPayment',
      'setErrorCode',
      'openAddNew',
      'setContactArray',
      'setContactType',
      'initContact'
    ]),
    getFormTitle () {
      if (this.getAliasList.customer) {
        let module = {
          'customerContact': (this.getAliasList.customer || '客户') + '联系人',
          'customerApi': this.getAliasList.customer || '客户',
          'opportunityApi': this.getAliasList.salesOpportunity || '销售机会',
          'contractApi': this.getAliasList.contract || '合同订单',
          'contactApi': this.getAliasList.contact || '联系人',
          'communicateApi': this.getAliasList.customerCommunicate || '跟进记录',
          'communicatePlan': this.getAliasList.communicatePlan || '访客计划'
        }
        return module[this.moduleName]
      } else {
        return ''
      }
    },
    fuction (item) {
      if (this.addnewProp.id && this.moduleName === 'workReportApi' && item.attr === 'reportDate') {
        return true
      }
      return false
    },
    // 清空原有数据
    clearData () {
      this.form = {}
      this.formData = []
      this.rules = {}
      this.isApproval = false
      this.saleStage = false
      this.updateSelect([])
    },
    // 新建客户时新建联系人
    customerAddContact () {
      // 清除原有数据
      this.clearData()

      this.formData = JSON.parse(JSON.stringify(this.explains))

      if (this.curContact.form.name) {
        this.form = this.curContact.form
      } else {
        this.setInitAttrValue(this.formData)
      }

      this.setRules(this.formData)

      this.$nextTick(() => {
        this.dialogFormVisible = true
        this.showModal = true
      })
    },
    // 初始化
    initAddnew () {
      // 清除原有数据
      this.clearData()
      let url = `/${this.moduleName}/${this.addnewProp.id ? 'edit' : 'item'}.html`
      if (this.moduleName === 'customerApi') {
        let id = this.addnewProp.id ? this.addnewProp.id : 'item'
        let str = 'customerApi-' + id
        this.setContactType(str)
        this.initContact()
      }
      let params = {
        templateId: this.addnewProp.templateId || this.templateId || '',
        id: this.addnewProp.id,
        formCopyId: this.addnewProp.formCopyId,
        opportunityId: this.addnewProp.opportunityId,
        refId: this.addnewProp.refId,
        type: this.addnewProp.type,
        stageCode: this.addnewProp.stageCode,
        reportStartDate: this.addnewProp.reportStartDate,
        relationId: this.addnewProp.relationId,
        refIds: this.addnewProp.refIds,
        workOrderTemplateId: this.templateId, // 工单模板id
        originId: this.addnewProp.originId,   //  红冲发票原始id
        isRed: this.addnewProp.isRed,          //   回款红冲
        modelType: this.addnewProp.modelType,   //  新建模块类型 比如坏账 红冲
        isBad: this.addnewProp.isBad            //  确认是还原还是坏账
      }

      // 从呼叫中心新建客户，需传入客户的电话号码
      if (this.addnewProp.phone) {
        params.phone = this.addnewProp.phone
      }

      api.post(url, params, (data) => {
        this.addnewProp.templateId = ''
        this.dialogFormVisible = true
        this.showModal = true
        // 跟进记录额外字段
        if (this.moduleName === 'communicateApi' && !this.addnewProp.id) {
          this.form = {
            followTime: '',
            notifyType: 0,
            notifyTime: '',
            content: '',
            plan: true
          }
          this.rules = {
            followTime: { required: true, message: '请选择跟进时间', trigger: 'change' },
            notifyType: { type: 'number', required: true, message: '请选择提醒类型', trigger: 'change' },
            notifyTime: { required: true, message: '请选择提醒时间', trigger: 'change' },
            content: { required: true, message: '请输入备注内容', trigger: 'blur' }
          }
        }
        this.setInitAttrValue(data.result)

        // 客户,合同模块需要对客户名称进行查重
        if (this.moduleName === 'customerApi') {
          this.isNameCheck = data.isCustomerNameCheck || false
          this.isCheckRepeat = data.isCheckRepeat || false
        }
        if (this.moduleName === 'contractApi') {
          this.isNameCheck = data.isContractNameCheck || false
        }
        this.isPhoneCheck = data.isPhoneCheck || false

        // 发票管理额外信息
        this.invoice = data.customerInvoice
        this.express = data.customerExpress
        this.isApproval = data.isApproval
        this.formData = data.result

        this.setRules(data.result)

        // 入库单，取消对关联单据的验证
        if (this.moduleName === 'instock') {
          delete this.rules.refId
        }

        // 采购合同编辑时，需传入供应商ID
        if (this.addnewProp.id && this.moduleName === 'purchase') {
          this.formData.forEach(item => {
            if (item.attr === 'supplierId') {
              this.setSupplierId(item.attrValue.id)
              return
            }
          })
        }

        // 编辑时，部分模块产品选择需要关联仓库ID
        if (this.addnewProp.id && ['inventory', 'transfer', 'outstock', 'assemble'].indexOf(this.moduleName) > -1) {
          this.formData.forEach(item => {
            if (item.attr === 'warehouseId' || item.attr === 'outWarehouseId') {
              this.setWarehouseId(item.attrValue.id)
              return
            }
          })
        }
        // 销售阶段，如果没有可填写的字段，则显示
        if (!this.formData.length) {
          this.saleStage = true
        }
        // 获取opUUID
        this.opUUID = data.opUUID

        // 添加汇款单时,如果回款金额变小，出现预计回款时间
        if (this.moduleName === 'paymentSheetApi') {
          //  当this.form.amount为undefined的时候 会报错 所以这里进行了下判断
          if (this.form.amount) {
            this.paymentAmount = JSON.parse(JSON.stringify(this.form.amount))
          }
        }

        if (this.moduleName === 'customerInvoice') {
          this.form.titleType = this.form.titleType && Number(this.form.titleType) ? this.form.titleType : '1'
        }

      }, (errorData) => {
        // 新建或编辑失败时，关闭当前弹窗
        this.$emit('closeDialog')
        this.$emit('closeForDetail')
      })
    },
    // 设置初始值
    setInitAttrValue (data) {
      // 设置初始值
      data.forEach((obj) => {
        if (obj.fieldType === 10) {
          Vue.set(this.form, obj.attr, Number(obj.attrValue))
        } else if (obj.fieldType === 2) {
          Vue.set(this.form, obj.attr, obj.attrValue === '' ? '' : Number(obj.attrValue))
        } else if (obj.fieldType === 4) {
          Vue.set(this.form, obj.attr, obj.attrValue || (!obj.isRedundant ? utils.formatDate() : ''))
        } else if (obj.fieldType === 9) {
          Vue.set(this.form, obj.attr, obj.attrValue ? obj.attrValue.split('|') : [])
        } else if ([5, 6, 8].indexOf(obj.fieldType) > -1) {
          if (!obj.attrValue) {
            obj.attrValue = '[]'
          }
          Vue.set(this.form, obj.attr, JSON.parse(obj.attrValue))
        } else if (obj.fieldType === 7 || obj.fieldType === 1) {
          Vue.set(this.form, obj.attr, obj.attrValue || obj.initValue || '')
        } else if (obj.fieldType === 1501) {
          Vue.set(this.form, obj.attr, {id: '', value: obj.attrValue, visitPlanInfo: ''})
        } else {
          Vue.set(this.form, obj.attr, obj.attrValue)

          // 初始化关联产品
          if (obj.attr === 'products' && obj.attrValue.productList) {
            this.updateSelect(obj.attrValue.productList)
          } else if (obj.attr === 'products' && obj.attrValue.length) {
            this.updateSelect(obj.attrValue)
          }

          // 如果是合同和机会里的products
          if (['contractApi', 'opportunityApi'].indexOf(this.moduleName) > -1 && obj.attr === 'products') {
            this.secondProductList = obj.attrValue
            this.form.products = {}
            Vue.set(this.form.products, 'productList', obj.attrValue ? obj.attrValue : [])
            if (this.moduleName === 'contractApi') {
              this.secondProductList = obj.attrValue.productList || []
              Vue.set(this.form.products, 'productList', obj.attrValue.productList || [])
              Vue.set(this.form.products, 'surchargeList', obj.attrValue.surchargeList ? obj.attrValue.surchargeList : [])
            }
            // 产品精度
            if (obj.decimalPrecisionMap) {
              this.decimalPrecisionMap = obj.decimalPrecisionMap
            }

          // 供应商
          } else if (obj.attr === 'productList') {
            Vue.set(this.form, obj.attr, obj.attrValue || [])
          // 工单
          } else if (['workOrder'].indexOf(this.moduleName) > -1 && obj.attr === 'products') {
            this.secondProductList = obj.attrValue
            Vue.set(this.form, obj.attr, obj.attrValue || [])
            // 产品精度
            if (obj.decimalPrecisionMap) {
              this.decimalPrecisionMap = obj.decimalPrecisionMap
            }
          }

          if (this.moduleName === 'contractApi' && obj.attr === 'payment') {
            this.isAmountEquals = obj.isAmountEquals
          }
        }

        // 特殊日期类型
        if (obj.attr === 'communicateTime') {
          Vue.set(this.form, obj.attr, obj.attrValue || utils.formatDate('', 'datetime'))
        }
      })
    },
    setRules (data) {
      data.forEach((obj) => {
        // 配置验证规则
          // 字符串
        if (obj.required && [1, 7].indexOf(obj.fieldType) > -1) {
          Vue.set(this.rules, obj.attr, { required: true, message: `请输入${obj.attrName}`, trigger: 'blur' })
          // 电话号码查重
        } else if (obj.attr === 'phone') {
          // 当isPhoneCheck为true时，对电话进行查重验证
          if (obj.required && this.isPhoneCheck) {
            Vue.set(this.rules, 'phone', { validator: this.checkPhoneRequired, required: true, attrName: obj.attrName, trigger: 'change' })
          } else if (obj.required) {
            Vue.set(this.rules, 'phone', { validator: this.phoneRequired, required: true, attrName: obj.attrName, trigger: 'change' })
          } else if (this.isPhoneCheck) {
            Vue.set(this.rules, 'phone', { validator: this.checkPhone, message: `已开启号码判重，请填写${obj.attrName}`, trigger: 'change' })
          }
        } else if (obj.attr === 'products' && obj.required) {
          // 产品必填验证
          Vue.set(this.rules, 'products', { required: true, validator: this.validateProducts, message: `请选择${obj.attrName}`, trigger: 'change' })
          // 合同里回款计划的验证(只是为了出现红点，是假的验证)
        } else if (obj.attr === 'payment' && obj.required) {
          this.checkPayments = true
          Vue.set(this.rules, obj.attr, { required: true, validator: this.validatePayment })
        } else if ((obj.attr === 'addContact' && obj.required)) {
          Vue.set(this.rules, obj.attr, { required: true, validator: this.validateContact })
        } else if (obj.fieldType === 0) {
          // 必填+查重
          if (obj.required && this.isNameCheck && obj.attr === 'name') {
            Vue.set(this.rules, obj.attr, { validator: this.nameCheckRequired, required: true, attrName: obj.attrName, type: obj.validate, trigger: 'change' })
            // 仅查重
          } else if (this.isNameCheck && obj.attr === 'name') {
            Vue.set(this.rules, obj.attr, { validator: this.nameCheck, type: obj.validate, trigger: 'change' })
            // 仅必填
          } else if (obj.required) {
            Vue.set(this.rules, obj.attr, { required: obj.required, type: obj.validate, message: `请选择${obj.attrName}`, trigger: 'change' })
          }
          // 编辑时查重不能查原来的名字
          if (obj.attr === 'name') {
            this.checkName = obj.attrValue
          }
         // 数字
        } else if (obj.fieldType === 2) {
          Vue.set(this.rules, obj.attr, { validator: checkNumber, required: !!obj.required, attrName: obj.attrName, num: obj.decimalPrecision, trigger: 'change' })
          // 日期
        } else if (obj.fieldType === 4 && obj.required) {
          Vue.set(this.rules, obj.attr, { validator: checkDate, required: true, message: `请选择${obj.attrName}`, trigger: 'change' })
          // 数组
        } else if ([5, 6, 8, 9].indexOf(obj.fieldType) > -1 && obj.required) {
          Vue.set(this.rules, obj.attr, { required: true, type: 'array', message: `请选择${obj.attrName}`, trigger: 'change' })
          // 星星
        } else if (obj.fieldType === 10 && obj.required) {
          Vue.set(this.rules, obj.attr, { validator: this.checkStar, message: `请选择${obj.attrName}`, required: true, trigger: 'change' })
          // 生日类型
        } else if (obj.fieldType === 37 && obj.required) {
          Vue.set(this.rules, obj.attr, { required: true, message: `请选择${obj.attrName}` })
          this.birthdayRequired = true
          // 跟进记录客户类型
        } else if (obj.fieldType === 40 && obj.required) {
          Vue.set(this.rules, obj.attr, { required: true, type: obj.validate, message: `请选择${obj.attrName}` })
          // 跟进记录跟进业务
        } else if (obj.fieldType === 41 && obj.required) {
          Vue.set(this.rules, obj.attr, { required: true, type: obj.validate, message: `请选择${obj.attrName}` })
          // 其他类型
        } else if (obj.required && obj.fieldType !== 0) {
          Vue.set(this.rules, obj.attr, { required: true, type: obj.validate || 'string', message: `请选择${obj.attrName}`, trigger: 'change' })
        }
      })
    },

    // 工作报告的新建
    datepicker (item) {
      if (this.moduleName === 'workReportApi' && item.attr === 'reportDate') {
        this.addnewProp.reportStartDate = this.form[item.attr]
        this.initAddnew()
      }
    },

    // 是否开启下次跟进提醒
    remindChange (bool) {
      this.nextRemind = bool
    },
    strToArr (str) {
      if (str) {
        return str.split('|')
      }
      return []
    },
    // 格式化要提交的数据
    formatData (formData, form) {
      let defaultData = {}
      let redundantData = {}
      // 工作报告的新建
      if (this.moduleName === 'workReportApi') {
        let data = JSON.parse(JSON.stringify(formData))
        data.forEach((item) => {
          if (item.fieldType !== 0) {
            item.attrValue = (form[item.attr] !== undefined) ? form[item.attr] : ''
          }
          if (item.attr === 'thisPlan') {
            for (let i = 0; i < item.attrValue.length; i++) {
              item.attrValue[i].status = item.attrValue[i].status ? 1 : 0
            }
          }
        })
        return {'explains': data}
      }
      formData.forEach((item) => {
        // 如果是多选类型，先将数组转为字符串再保存
        if (item.fieldType === 9) {
          let value = form[item.attr]
          let formatCheckbox = value ? value.join('|') : value
          Vue.set(item.isRedundant ? redundantData : defaultData, item.attr, formatCheckbox)
        } else if (item.attr === 'communicateBusiness') {
          let value = JSON.parse(JSON.stringify(form[item.attr]))
          Vue.set(item.isRedundant ? redundantData : defaultData, item.attr, {refType: item.selectControl.attrValue, refId: value.id} || {})
        } else if (item.attr === 'addContact') {
          let array = []
          this.contactArray.map((item, i) => {
            let obj = {
              id: item.id,
              operate: item.operate
            }
            let isPush = true
            if (item.isEdit) {
              obj.explains = this.formatData(this.explains, item.form)
            } else {
              if (item.id && item.id !== '0') {
                isPush = false
              } else {
                obj.explains = item.explains
              }
            }
            if (isPush) {
              array.push(obj)
            }
          })
          this.delContactArray.map((item) => {
            let obj = {
              id: item.id,
              operate: 'd'
            }
            array.push(obj)
          })
          Vue.set(item.isRedundant ? redundantData : defaultData, item.attr, array)
        } else if (item.attr === 'payment') {
          Vue.set(item.isRedundant ? redundantData : defaultData, item.attr, this.paymentForm)
        } else {
          Vue.set(item.isRedundant ? redundantData : defaultData, item.attr, (form[item.attr] !== undefined && form[item.attr] !== null) ? form[item.attr] : '')
        }

        // 如果是合同和机会里的products
        if (['contractApi', 'opportunityApi'].indexOf(this.moduleName) !== -1 && item.attr === 'products') {
          if (this.moduleName === 'contractApi') {
            form.products.surchargeList = form.products.surchargeList.map(item => {
              let obj = {}
              obj = {
                'id': item.id || 0,
                'surchargeName': item.surchargeName,
                'surchargeType': item.surchargeType,
                'amount': item.surchargeType === 2 ? -item.amount : item.amount
              }
              return obj
            })
          }
          form.products.productList = form.products.productList.map(item => {
            let obj = {}
            obj = {
              'id': item.itemId || 0,
              'name': item.name,
              'num': item.num,
              'productPrice': item.productPrice,
              'discount': item.discount,
              'specification': item.specification,
              'estimateCost': item.estimateCost, // 预估成本
              'productId': item.productId || item.id
            }
            // 合同产品备注保存
            if (this.moduleName === 'contractApi') {
              obj.memo = item.memo
            }
            return obj
          })
        }
      })
      if (this.addnewProp.id) {
        Vue.set(defaultData, 'id', this.addnewProp.id)
      }
      // 供应商详情页新建供应商联系人
      if (this.addnewProp.module === 'supplierContact') {
        Vue.set(defaultData, 'supplierId', this.addnewProp.supplierId || this.addnewProp.refId)
      }
      // 销售阶段
      if (this.addnewProp.stageCode) {
        Vue.set(defaultData, 'code', this.addnewProp.stageCode)
        Vue.set(defaultData, 'opportunityId', this.addnewProp.opportunityId)
      }
      // 下次跟进提醒
      if (this.nextRemind) {
        defaultData.followTime = form.followTime
        defaultData.notifyType = form.notifyType
        defaultData.content = form.content
        defaultData.plan = form.plan
        if (form.notifyType === 5) {
          defaultData.notifyTime = form.notifyTime
        }
      }
      // 公海客户
      if (this.routeChild) {
        defaultData.child = this.routeChild
      }
      // 发票详情编辑
      if (this.moduleName === 'customerInvoice' || this.moduleName === 'customerExpress') {
        defaultData.refId = this.addnewProp.refId
      }

      // 发票编辑
      if (this.moduleName === 'invoice') {
        let addInvoice = this.$refs.addInvoice
        if (addInvoice) {
          let invoice = addInvoice.invoiceData || '' // 发票信息
          let express = addInvoice.expressData || '' // 配送信息

          if (invoice && express) {
            if (invoice.id) {
              invoice.customerInvoiceId = invoice.id
              delete invoice.id
            }

            if (express.id) {
              express.customerExpressId = express.id
              delete express.id
            }

            invoice = Object.assign(invoice, express) // 合并对象
            for (let item in invoice) {
              defaultData[item] = invoice[item]
            }
          }
        }
      }

      // 新建退货退款
      if (this.moduleName === 'refund') {
        let invoiceIds = this.checkedInvoices.filter(item => item) // 只保留有效的id
        let paymentSheets = this.checkedPaymentSheets.filter(item => item) // 只保留有效的id

        defaultData.invoiceIds = invoiceIds
        defaultData.paymentSheets = paymentSheets
        defaultData.refundAmount = this.refundAmount
      }

      // 在详情页添加跟进记录时，需添加type属性
      if (this.addnewProp.module === 'communicateApi') {
        return {'defaultData': defaultData, 'redundantData': redundantData, 'type': this.addnewProp.type, 'opUUID': this.opUUID}
      }

      //  回款单的新建 当是红冲或者坏账特殊情况的时候 需要加modelType属性
      if (this.addnewProp.module === 'paymentSheetApi') {
        let paymentSheets = this.checkedPaymentSheets.filter(item => item)
        defaultData.paymentSheets = paymentSheets
        defaultData.refundAmount = this.refundAmount
        defaultData.refId = this.addnewProp.refId

        // 新建回款单时，下次预计汇款时间不显示时，把值清空
        if (!this.nextPayAmount) {
          defaultData.estimateTime = undefined
        }
        return {'defaultData': defaultData, 'opUUID': this.opUUID, modelType: this.addnewProp.modelType}
      }
      return {'defaultData': defaultData, 'redundantData': redundantData, 'opUUID': this.opUUID}
    },
    // 提交数据
    sendData () {
      const that = this
      let url = `/${this.moduleName}/save.html`
      api.post(url, this.formatData(this.formData, this.form), (data) => {
        const that = this
        Message({
          type: 'success',
          message: data.isApprovalMsg || data.msg || '保存成功！',
          duration: 1000,
          onClose: function () {
            that.updateSelect([]) // 清空已选商品
            that.closeDialog()

            // 销售机会填写完阶段反馈后要改变销售阶段
            /* 这里将stageCode改成nextStageCode，点击阶段跳转时有nextStageCode这个参数，
            *通过填写反馈和编辑反馈不会传这个参数，这时候会走else
            */
            if (that.moduleName === 'stageFeedbackApi' && that.addnewProp.nextStageCode) {
              that.$emit('changeOppStage')
              return
            } else {
              if (!data.isApproval) {
                that.$emit('refresh')
              }
            }

            // 判断是否开启审批
            if (data.isApproval && that.addnewProp.id) {
              that.$emit('callback', that.addnewProp.module)
              return
            }

            // 判断是否中标
            if (data.isWin && !data.isApproval) {
              let argu = {
                id: data.opportunityId,
                name: data.salesStageName
              }
              that.$emit('callback', 'opportunityApi', argu)
            } else if (data.salesStageType === 2) {
              // todo 输单
              that.$emit('closeConfirm', data.opportunityId)
            }

            // 设置完成访客计划相关
            // if (data.plans && data.plans.length) {
            //   that.$emit('communicatePlan', data.plans)
            // }
            if (that.moduleName === 'contractApi') {
              that.checkPayment(false)
            }
          }
        })
      }, () => {
        if (that.moduleName === 'contractApi') {
          that.checkPayment(false)
        }
      })
    },
    saveCustomerAddContact () {
      let obj = {
        'id': this.addnewProp.id,
        'operate': this.addnewProp.operate,
        'key': this.addnewProp.key,
        'isEdit': this.addnewProp.isEdit,
        'form': this.form,
        'explains': this.formatData(this.formData, this.form),
        'name': this.form.name,
        'phone': this.form.phone[0].telNum
      }
      let object = {
        contact: obj
      }
      this.setContactArray(object)
      this.$nextTick(() => {
        this.setAttr('addContact')
        this.closeDialog()
      })
    },
    // 提交前校验表单
    handleSubmit (ev) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // 生日格式比较特殊，单独验证
          if (this.birthdayRequired) {
            let date = this.form.birthday
            if (!(date.birthday || date.lunarBirthday)) {
              Message({
                type: 'error',
                message: '生日为必填字段，请补充完整后提交！'
              })
              return
            }
          }

          if (this.moduleName === 'contractApi') {
            // 对回款计划进行验证
            this.checkPayment(true)
            this.$nextTick(() => {
              let len = this.editPaymentData.length + this.addPaymentData.length
              if (this.checkPayments && !this.paymentForm.length && !len) {
                Message({
                  type: 'error',
                  message: '回款计划不能为空'
                })
                this.checkPayment(false)
              } else {
                if (this.paymentForm.length === len) {
                  this.sendData()
                } else {
                  this.checkPayment(false)
                  return false
                }
              }
            })
          } else if (this.addnewProp.relation === 'contactApi') {
            this.saveCustomerAddContact()
          } else {
            this.sendData()
          }
        } else {
          Message({
            type: 'error',
            message: '输入有误，请检查后重新提交！'
          })
          return false
        }
      })
    },
    // 显示产品选择弹窗
    productShow (type, nonEditable) {
      this.nonEditable = Boolean(nonEditable)
      this.productType = type
      this.productCAOshow = true
    },

    // 已选产品(为了重复添加)
    selectId (arr) {
      this.selectIdArr = arr
    },
    // 去掉价格中间的‘，’
    formatProductPrice (value) {
      return Number((value + '').replace(/,/g, ''))
    },
    // 获取关联的商品信息 （机会、合同、工单）
    getCAOProductsData (products, totalMoney, surchargeList) {
      this.productCAOshow = false
      if (this.moduleName === 'contractApi' || this.moduleName === 'opportunityApi') {
        this.form.products = {}
        if (surchargeList) {
          this.form.products.surchargeList = surchargeList
        }
        this.form.products.productList = products
        // 合同、机会金额小数精度
        this.formData.forEach(item => {
          if (item.attr === 'totalMoney') {
            let toFixedTotalMoney = Number(totalMoney.toFixed(item.decimalPrecision))
            this.$set(this.form, 'totalMoney', toFixedTotalMoney)
          }
        })
      } else if (this.moduleName === 'workOrder') {
        this.form.products = products
      }
      this.setAttr('products')
    },

    // JXC产品弹框获取产品信息
    getProductList (arr) {
      this.productsDialog = true
      // 合同、机会
      if (this.moduleName === 'contractApi' || this.moduleName === 'opportunityApi' || this.moduleName === 'workOrder') {
        this.secondProductList = arr
      // 供应商
      } else {
        let proArr = []
        arr.map((item) => {
          let proObj = {}
          proObj = {
            id: item.id
          }
          proArr.push(proObj)
        })
        Vue.set(this.form, 'productList', proArr)
      }
      // this.$nextTick(() => {
      //   this.$refs.products.dialogVisible = true
      // })
    },

    // 验证星星
    checkStar (rule, value, callback) {
      if (!value || value < 1) {
        callback(new Error())
      } else {
        callback()
      }
    },
    // 异步验证
    asycnCheck (cb) {
      clearTimeout(lazy)
      lazy = setTimeout(() => {
        cb()
      }, 300)
    },
    // 电话号码必填验证
    phoneRequired (rule, value, callback) {
      this.asycnCheck(() => {
        // 当用户粘贴电话号码时，无法获取到value的值，所以直接获取form中的值来验证
        value = value.length ? value : this.form.phone
        // 判断是否有telNum为空的情况
        let phone = true
        value.map(item => {
          let num = (item.telNum + '').replace(/\s/g, '')
          if (!num) {
            phone = false
          }
          return item
        })
        this.form.phone = value
        if (this.form.phone.length && phone) {
          callback()
        } else {
          callback(new Error(`请填写${rule.attrName}`))
        }
      })
    },
    // 自定义电话号码必填验证
    checkPhoneRequired (rule, value, callback) {
      this.asycnCheck(() => {
        // 当用户粘贴电话号码时，无法获取到value的值，所以直接获取form中的值来验证
        value = value.length ? value : this.form.phone
        // 判断是否有telNum为空的情况
        let phone = true
        value.map(item => {
          let num = (item.telNum + '').replace(/\s/g, '')
          if (!num) {
            phone = false
          }
          return item
        })
        this.form.phone = value
        if (this.form.phone.length && phone) {
          this.checkRepeat(value, 'phone', callback)
        } else {
          callback(new Error(`请填写${rule.attrName}`))
        }
      })
    },
    // 自定义电话号码查重规则
    checkPhone (rule, value, callback) {
      value = value.length ? value : this.form.phone
      if (value && value.length) {
        let phone = true
        value.map(item => {
          let num = (item.telNum + '').replace(/\s/g, '')
          if (!num) {
            phone = false
          }
          return item
        })
        if (!phone) {
          callback(new Error())
        }
        this.form.phone = value
        this.asycnCheck(() => {
          this.checkRepeat(value, 'phone', callback)
        })
      } else {
        callback()
      }
    },
    // 查重
    checkRepeat (value, type, callback) {
      if (value) {
        if (this.checkName === value) {
          callback()
          return
        }
        let url = '/commonApi/checkRepeate.do'
        let params = {
          isFocus: 1
        }
        let msg = ''
        if (type === 'phone') {
          params.checkObj = 'phone'
          params.phone = value
          params.customerId = this.addnewProp.id
        } else if (type === 'customerApi') {
          params.checkObj = 'customerName'
          params.customerName = value
          msg = '系统中已存在此客户名称，请重新输入!'
          params.customerId = this.addnewProp.id || 0
        } else {
          params.checkObj = 'contractName'
          params.contractName = value
          msg = '系统中已存在此合同名称，请重新输入!'
          params.contractId = this.addnewProp.id || 0
        }
        api.post(url, params, (data) => {
          // 客户和合同查询需要有个列表
          if (type !== 'phone') {
            this.checkListData = data.list
          }
          if (!data.success) {
            if (type === 'phone') {
              if (data.phone) {
                msg = '系统中已存在此' + data.phone + '号码，请重新输入!'
              } else {
                msg = '请填写电话号码!'
              }
            }
            callback(new Error(msg))
          } else {
            callback()
          }
        })
      }
    },

    // 自定义验证产品必填
    validateProducts (rule, value, callback) {
      if (value.productList && value.productList.length) {
        callback()
      } else if (this.moduleName === 'workOrder' && value && value.length) {
        callback()
      } else {
        callback(new Error())
      }
    },

    // 自定义名称查重，名称必填
    nameCheckRequired (rule, value, callback) {
      this.checkListData = []
      value = value.replace(/\s/g, '')
      if (value) {
        this.checkRepeat(value, this.moduleName, callback)
      } else {
        callback(new Error(`请填写${rule.attrName}`))
      }
      // this.asycnCheck(() => {
      // })
    },

    // 自定义名称查重，名称不必填
    nameCheck (rule, value, callback) {
      this.checkListData = []
      value = value.replace(/\s/g, '')
      if (value) {
        this.checkRepeat(value, this.moduleName, callback)
      } else {
        callback()
      }
      // this.asycnCheck(() => {
      // })
    },
    // 监听下拉选择
    selectHandle (attr) {
      if (attr === 'type' && (this.moduleName === 'instock' || this.moduleName === 'outstock')) {
        if (this.form.type === '5') {
          this.form.refId = {}
        } else {
          this.form.refId = ''
        }
        this.form.products = []
      }
    },

    addNew (obj) {
      this.addnewPropCopy = obj
      if ((obj && obj.module === 'contractApi') || ((!obj || (obj && !obj.module)) && this.moduleName === 'contractApi')) {
        let str = obj && obj.id ? 'edit' : 'item'
        this.setPaymentType('contractApi-' + str)
        this.initPayment()
      }
      // 新建客户时新建联系人
      if (!this.addnewShow) {
        this.addnewShow = true
      } else {
        // 获取子组件的props
        const childAnp = this.$refs.addNew.addnewProp // 已经传给子组件的props
        const parentAnp = this.addnewProp // 即将传给子组件的props

        /*
          * childAnp 条件成立时，说明新建窗口被打开过，并且没有被销毁
          * childAnp.id，有id值，说明上一次是编辑操作
          * childAnp.module 有module，说明上一次操作是另一个模块的新建动作
          * parentAnp 存在id属性说明当前操作时编辑，不是新建
          * parentAnp 存在module属性说明当前要打开另一个模块的新建
        */
        if (childAnp && childAnp.id || childAnp && childAnp.module || parentAnp.id || parentAnp.module) {
          this.addnewShow = false
          this.$nextTick(() => {
            this.addNew(obj)
          })
        } else {
          if ((obj && obj.module === 'customerApi') || (obj && obj.moduleName === 'customerApi')) {
            let id = obj.id ? obj.id : 'item'
            let str = 'customerApi-' + id
            this.setContactType(str)
          } else if (!obj && this.moduleName === 'customerApi') {
            let str = 'customerApi-item'
            this.setContactType(str)
          }
          this.$refs.addNew.dialogFormVisible = true
        }
      }
    },

    refresh () {
      if (this.$refs[this.moduleName]) {
        for (let i = 0; i < this.$refs[this.moduleName].length; i++) {
          if (this.$refs[this.moduleName][i].$refs.associatedField) {
            this.$refs[this.moduleName][i].refresh()
          }
        }
      }
    },

    // 监听合并开票是否不可编辑金额
    isMoneyEditable (item) {
      if (item.attr === 'totalMoney' && item.attrName === '开票金额') {
        if ((this.form.contractId && this.form.contractId.length > 1) || (this.form.paymentId && this.form.paymentId.length > 1)) {
          return true
        }
        return false
      }
      return false
    },

    isShowNextPayAmount (item) {
      if (item.attr === 'amount' && this.moduleName === 'paymentSheetApi') {
        // 现支持小数位数6位
        if ((parseFloat(this.paymentAmount) - this.form.amount) >= 0.0000001) {
          this.nextPayAmount = true
        } else {
          this.nextPayAmount = false
        }
      }
    },

    // 超出小数位的处理
    onInput (item) {
      var value = this.form[item.attr].toString()
      if (value.indexOf('.') !== -1) {
        var precisionLen = value.split('.')[1].length // 获取input输入小数位的长度
        if (precisionLen > item.decimalPrecision) {
          setTimeout(() => {
            // 如果小数位超出，则保留有效小数位
            this.form[item.attr] = value.substr(0, value.indexOf('.') + item.decimalPrecision + 1)
          }, 1500)
        }
      }
    },

    // 退货退款，更新退款总金 额
    updateRefundAmount (num) {
      this.refundAmount = num
    },

    // 退货金额
    refundProTotalMoney (num) {
      let numNumber = Number(num)
      this.formData.forEach(item => {
        if (item.attr === 'returnAmount') {
          let toFixedTotalMoney = Number(numNumber.toFixed(item.decimalPrecision))
          this.$set(this.form, 'returnAmount', toFixedTotalMoney)
        }
      })
    },

    // 获取访客计划列表
    getVisitPlanList (data) {
      this.visitPlanList = data
    },

    // 打开访客计划列表
    communicatePlan (selectVisitPlan) {
      this.$emit('communicatePlan', this.visitPlanList, selectVisitPlan)
    },

    // 监听子组件的emit事件
    handleFieldEmit (value, type) {
      // 工单模板选择
      this.templateId = value
      if (type === 'temp') {
        this.initAddnew()
      }
    },

    closeDialog () {
      this.openAddNew({ isOpenAddNew: false })
      this.$emit('closeForDetail')
      this.$emit('closeDialog')
    },

    //  取消弹窗
    cancelDialog () {
      this.dialogFormVisible = false
      this.showModal = false
      if (this.addnewProp.relation === 'contactApi') {
        this.openAddNew({isOpenAddNew: false})
        this.$emit('closeDialog')
      }
    },

    validatePayment (rule, value, callback) {
      callback()
    },

    validateContact (rule, value, callback) {
      if (this.contactArray.length) {
        callback()
      } else {
        callback(new Error('请添加联系人'))
      }
    }
  },
  filters: {
    arrToStr (arr) {
      return arr.join(',')
    }
  },
  watch: {
    form: {
      handler () {
        // console.log('form', this.form)
      },
      deep: true
    },
    // 监听异步验证字段
    getAttr (attr) {
      if (this.rules[attr]) {
        this.$refs.ruleForm.validateField(attr)
        this.setAttr('')
      }
    },
    // 监听错误码
    getErrorCode (newCode) {
      // 当返回错误码19时（超出截止时间），关闭弹框
      if (newCode === 19 && ['workReportApi', 'paymentApi'].indexOf(this.moduleName) > -1) {
        this.closeDialog()
        this.setErrorCode(1)
      }
    },
    isOpenAddNew (value) {
      if (value) {
        let id = this.addnewProp.id ? this.addnewProp.id : 'item'
        let str = this.moduleName + '-' + id
        if (str === this.contactType) {
          let obj = {
            relation: 'contactApi',
            module: 'contactApi',
            id: this.curContact.id,
            operate: this.curContact.operate,
            key: this.curContact.key,
            isEdit: this.curContact.isEdit
          }
          this.addNew(obj)
        }
      }
    }
  },
  components: {
    supplier,
    purchase,
    returnedPurchase,
    transfer,
    inventory,
    instock,
    outstock,
    selectProduct,
    products,
    vUpload,
    customerApi,
    contactApi,
    opportunityApi,
    contractApi,
    communicateApi,
    assemble,
    'supplierContact': supplier,
    customerExpress,
    invoice,
    addInvoice,
    workReportApi,
    Birthday,
    paymentSheetApi,
    addNew,
    refund,
    addRefund,
    workOrder,
    addPayment
  }
}
</script>

<style lang="less">
.addnew-from {
  margin-right: 50px;
  .customer {
    .el-select {
      width: 100%;
    }
  }
  .el-date-editor {
    width: 217px;
  }
  .v-warning {
    font-size: 16px;
    text-align: center;
    line-height: 3;
    color: red;
  }
  .el-checkbox-group {
    .el-checkbox {
      margin: 0 30px 0 0;
    }
    .el-checkbox__label {
      white-space: initial;
    }
  }
}
// .add-new {
//   .el-dialog {
//     overflow: hidden;
//     bottom: 0;
//   }
//   .el-dialog__body {
//     overflow: auto;
//     height: 100%;
//     padding-bottom: 112px;
//     box-sizing: border-box;
//   }
//   .el-dialog__footer {
//     position: absolute;
//     bottom: 0;
//     width: 100%;
//     z-index: 20;
//   }
// }
</style>



// WEBPACK FOOTER //
// add-new.vue?29db8709